import { ClipboardList, BellRing, DollarSign, KeyRound } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
    {
        icon: ClipboardList,
        title: "Sign up",
        body: "Join the spot deals list below with your trim, drivetrain, moonroof preference, and location.",
    },
    {
        icon: BellRing,
        title: "We notify you",
        body: "By text, email, or phone call — the moment your vehicle is allocated, with all specs on the vehicle including the exact price.",
    },
    {
        icon: DollarSign,
        title: "Remit the $699 fee",
        body: "The Spot Deal fee is due once your vehicle is allocated — never before.",
    },
    {
        icon: KeyRound,
        title: "Pick up within 1 week",
        body: "Take delivery within a week — but very often your RAV4 is available the same day.",
    },
];

export const SpotSteps = () => (
    <section id="how-spot-deals-work" data-testid="spot-steps-section" className="border-t border-white/10 py-28 sm:py-36">
        <div className="mx-auto max-w-7xl px-6">
            <Reveal>
                <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#2563EB]">
                    <span className="h-2 w-2 rotate-45 bg-[#2563EB]" aria-hidden="true" />
                    The process
                </p>
                <h2 className="max-w-3xl font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-tighter sm:text-5xl">
                    How spot deals work
                </h2>
            </Reveal>

            <div className="mt-20 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
                {STEPS.map((step, i) => (
                    <Reveal key={step.title} delay={i * 0.1} className="bg-[#050505]">
                        <article
                            data-testid={`spot-step-${i + 1}`}
                            className="group flex h-full flex-col p-8 transition-colors duration-500 hover:bg-[#0c0c0c]"
                        >
                            <div className="flex items-start justify-between">
                                <span className="font-display text-6xl font-extrabold tracking-tighter text-white/10 transition-colors duration-500 group-hover:text-[#2563EB]/40">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <step.icon className="h-6 w-6 text-[#2563EB]" aria-hidden="true" />
                            </div>
                            <h3 className="mt-10 font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
                                {step.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-zinc-400">
                                {step.body}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
